
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mintplus",
      function () {
        return require("private-next-pages/mintplus/index.tsx");
      }
    ]);
  